
import { defineComponent, PropType, reactive, computed } from 'vue'
import { useStore } from 'vuex'
import { Entry, RequestHandler } from '@Protium/vue-ozone-utils'
import { OperationalData } from '@/pages/Dashboard/components/interfaces/index'
import { generateTrackingUrl } from '@/utils/shipment'
import { Fulfillment, ShipmentLabel } from '@/models/interfaces/order'
import { Address } from '@/models/generics'
import useDocParser from '@/pages/composables/useDocParser'

interface DocumentViewerState {
  currentDialog: string,
  fulfillment: any,
  document: {
    labels: Array<any> | null,
    slip: Array<any> | null
  },
  dialog: {
    labels: boolean,
    slip: boolean
  }
}

export const formatObjectKey = (key: string) => {
  return key.charAt(0).toUpperCase() + key.slice(1).replace(/([A-Z])/g, ' $1').trim().toLowerCase()
}

export default defineComponent({
  name: 'OrderFulfillmentDetails',
  props: {
    order: {
      type: String,
      required: true
    },
    request: {
      type: Object as PropType<RequestHandler<Entry>>
    },
    data: {
      type: Object as PropType<{fulfillment: Fulfillment, labels: Array<ShipmentLabel>}>,
      required: true
    },
    address: {
      type: Object as PropType<Address>,
      required: true
    },
  },
  setup (props) {
    const $store = useStore()
    const $request = props.request || $store.getters['Services/Directr']
    const requestHandler = props.request || $store.getters['Services/Directr']

    const { ConvertZpltoPdfBase64 } = useDocParser()

    const state = reactive<DocumentViewerState>({
      currentDialog: '',
      fulfillment: null,
      document: {
        labels: null,
        slip: null
      },
      dialog: {
        labels: false,
        slip: false
      },
    })

    async function getPackingSlip (fulfillment) {
      // if (state.document.slip) {
      //   state.dialog.slip = true
      //   return
      // }

      closeDialogs()
      const { items: [document] } = await requestHandler.order.slip(props.order, fulfillment)

      state.document.slip = [document] // cast to array for easier templating
      state.currentDialog = 'slip'
      state.dialog.slip = true
    }

    async function getShipmentLabels (fulfillment) {
      state.fulfillment = fulfillment
      // if (state.document.labels) {
      //   state.dialog.labels = true
      //   return
      // }

      closeDialogs()
      let { items: documents } = await requestHandler.order.labels(props.order, fulfillment)

      // HOTFIX: api not returning correct pdf base64 for zpl
      if (documents?.[0] && !documents[0].startsWith('data:application') && !documents[0].startsWith('JVBER')) {
        documents = await ConvertZpltoPdfBase64(documents)
      }

      state.document.labels = documents.filter(Boolean)
      state.currentDialog = 'labels'
      state.dialog.labels = true
    }

    function closeDialogs () {
      Object.keys(state.dialog).forEach(d => {
        state.dialog[d] = false
      })
      state.currentDialog = ''
      state.document.labels = null
      state.document.slip = null
    }

    function reprintFulfillment (packing_slip?) {
      $request.put('order.print', props.order, { fulfillment: state.fulfillment, shipment_label: !packing_slip, packing_slip })
    }

    const trackingUrl = computed(() => {
      return (props.data?.fulfillment.shipments || []).map(shipment => {
        return [shipment.shipment || shipment.id, generateTrackingUrl(shipment.shipment || shipment.id, shipment.carrier, props.address)]
      })
    })

    return {
      state,
      trackingUrl,
      reprintFulfillment,
      getPackingSlip,
      getShipmentLabels,
      closeDialogs,
      formatObjectKey,
    }
  }
})
